import { combineReducers } from 'redux'
import { handleActions, combineActions } from 'redux-actions'

import {
  submit,
  submitSuccess,
  submitFailure,
  showJobApplication,
  closeJobApplication,
  loadAttachmentsSuccess,
  setDraftAttachmentsToReuse,
  loadJobForApplication,
  loadJobForApplicationSuccess,
  loadJobForApplicationError
} from './actions'
import defaultState, {
  defaultInfo,
  defaultAttachmentsToReuse,
  DEFAULT_JOB_LOADING,
  DEFAULT_JOB_FOR_APPLICATION,
  DEFAULT_EXCLUDE_IDS,
  DEFAULT_DISPLAY_JOB_FOR_APPLICATION_FORM,
  DEFAULT_ENABLE_JOB_FOR_APPLICATION
} from './defaultState'

export const visible = handleActions(
  {
    [showJobApplication]: () => true,
    [closeJobApplication]: () => false
  },
  defaultState.visible
)

export const submitting = handleActions(
  {
    [submit]: () => true,
    [combineActions(submitFailure, submitSuccess)]: () => false
  },
  defaultState.submitting
)

export const submitted = handleActions(
  {
    [combineActions(showJobApplication, closeJobApplication)]: () => false,
    [submitSuccess]: () => true
  },
  defaultState.submitted
)

export const errors = handleActions(
  {
    [combineActions(submit, closeJobApplication)]: () => {},
    [submitFailure]: (state, { payload }) => payload
  }, defaultState.errors
)

export const rate = handleActions(
  {
    [submitSuccess]: (state, { payload }) => ({ ...state, ...payload })
  }, defaultState.rate
)

// used by backstop tests
export const type = handleActions({
  // reset to default on show/close
  [combineActions(showJobApplication, closeJobApplication)]: () => defaultState.type
}, defaultState.type)

export const info = handleActions(
  {
    [closeJobApplication]: () => defaultInfo,
    [showJobApplication]: (state, { payload: { application } }) => ({ ...application })
  }, defaultInfo
)

export const attachmentsToReuse = handleActions(
  {
    [closeJobApplication]: () => defaultAttachmentsToReuse,
    [loadAttachmentsSuccess]: (state, { payload: { attachments } }) => ({ attachments }),
    [setDraftAttachmentsToReuse]: (state, { payload: { draft } }) => ({ draft })
  }, defaultAttachmentsToReuse
)

export const jobLoading = handleActions({
  [loadJobForApplication]: () => true,
  [combineActions(
    loadJobForApplicationSuccess, loadJobForApplicationError
  )]: () => false
}, DEFAULT_JOB_LOADING)

export const jobForApplication = handleActions({
  [loadJobForApplicationSuccess]: (state, { payload: { jobForApplication } }) => jobForApplication,
  [combineActions(loadJobForApplicationError, closeJobApplication)]: () => DEFAULT_JOB_FOR_APPLICATION
}, DEFAULT_JOB_FOR_APPLICATION)

export const excludeIds = handleActions({
  [loadJobForApplicationSuccess]: (state, { payload: { appliedJobId } }) => [...state, appliedJobId],
  [closeJobApplication]: () => DEFAULT_EXCLUDE_IDS
}, DEFAULT_EXCLUDE_IDS)

export const displayJobForApplicationForm = handleActions({
  [loadJobForApplicationSuccess]: (_, { payload }) => !!payload?.id,
  [closeJobApplication]: () => false
}, DEFAULT_DISPLAY_JOB_FOR_APPLICATION_FORM)

export const enableJobForApplication = handleActions({
  [showJobApplication]: (_, { payload: { enableJobForApplication = DEFAULT_ENABLE_JOB_FOR_APPLICATION } = {} } = {}) => enableJobForApplication,
  [closeJobApplication]: () => DEFAULT_ENABLE_JOB_FOR_APPLICATION
}, DEFAULT_ENABLE_JOB_FOR_APPLICATION)

export default combineReducers({
  submitting,
  submitted,
  visible,
  errors,
  rate,
  type,
  info,
  attachmentsToReuse,
  jobLoading,
  jobForApplication,
  excludeIds,
  displayJobForApplicationForm,
  enableJobForApplication
})
